import React from 'react';

import ContentCaseBottom from './content-case-bottom';
import ContentCaseHeader from './content-case-header';
import ContentCaseMiddle from './content-case-middle';
import FullWrapper from '../../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const ContentCase = ({ caseName, listTitle }) => {
    return (
        <FullWrapper caseName={caseName}>
            <div>
                <ContentCaseHeader listTitle={listTitle} />
                <ContentCaseMiddle listTitle={listTitle} />
                {listTitle[0].company ? <ContentCaseBottom listTitle={listTitle} /> : ''}
            </div>
        </FullWrapper>
    );
};
export default ContentCase;
